import { createContext, useState, useContext } from "react";

const CategoryContext = createContext();

export const CategoryProvider = ({ children }) => {
  const [activeCategory, setActiveCategory] = useState(1);

  const menuToCategoryId = {
    football: 1,
    lucky_numbers: 108,
    house_racing: 55,
    games: 107,
    tennis: 5,
  };

  const setCategoryByMenuId = (menuId) => {
    if (menuToCategoryId[menuId]) {
      setActiveCategory(menuToCategoryId[menuId]);
    }
  };

  return (
    <CategoryContext.Provider value={{ activeCategory, setActiveCategory, setCategoryByMenuId }}>
      {children}
    </CategoryContext.Provider>
  );
};

export const useCategory = () => useContext(CategoryContext);
